const Mutations = Object.freeze({
	SET_CLIENTS: 'projectClone/SET_CLIENTS',
	SET_PROJECTS: 'projectClone/SET_PROJECTS',
	SET_CLONE_OPTIONS: 'projectClone/SET_CLONE_OPTIONS',
});
export const Actions = Object.freeze({
	CLONE_PROJECT: 'projectClone/CLONE_PROJECT',
	GET_CLONE_OPTIONS: 'projectClone/GET_CLONE_OPTIONS',
	GET_CLIENTS: 'projectClone/GET_CLIENTS',
	GET_PROJECTS: 'projectClone/GET_PROJECTS',
});
export const Getters = Object.freeze({
	CLONE_OPTIONS: 'projectClone/CLONE_OPTIONS',
	CLIENTS: 'projectClone/CLIENTS',
	PROJECTS: 'projectClone/PROJECTS',
});

import dataService from '../../../../services/cloneProjectService';
import { GeneralActions } from '../../../actions';

export default {
	state: {
		loading: false,
		projects: [],
		clients: [],
		cloneOptions: [],
	},
	mutations: {
		[Mutations.SET_CLIENTS](state, items) {
			state.clients = items;
		},
		[Mutations.SET_CLONE_OPTIONS](state, items) {
			state.cloneOptions = items;
		},
		[Mutations.SET_PROJECTS](state, items) {
			state.projects = items;
		},
	},
	actions: {
		[Actions.CLONE_PROJECT]({ dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.cloneProject(item)
					.then(() => {
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						console.error(error);
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
		[Actions.GET_CLONE_OPTIONS]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.cloneOptions(item)
					.then((resp) => {
						commit(Mutations.SET_CLONE_OPTIONS, resp.data);
						dispatch(GeneralActions.LOADING, false);
						resolve(resp.data);
					})
					.catch((error) => {
						console.error(error);
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
		[Actions.GET_CLIENTS]({ commit, dispatch }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getClients()
					.then((resp) => {
						commit(Mutations.SET_CLIENTS, resp.data);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						console.error(error);
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
		[Actions.GET_PROJECTS]({ commit, dispatch }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getProjects(id)
					.then((resp) => {
						commit(Mutations.SET_PROJECTS, resp.data);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						console.error(error);
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
	},
	getters: {
		[Getters.CLONE_OPTIONS]: (state) => {
			if (state.cloneOptions.Entities) {
				state.cloneOptions.Entities.sort((a, b) =>
					a.Name > b.Name ? 1 : -1
				);
			}

			if (state.cloneOptions.Forms) {
				state.cloneOptions.Forms.sort((a, b) =>
					a.Name > b.Name ? 1 : -1
				);
			}
			if (state.cloneOptions.Activities) {
				state.cloneOptions.Activities.sort((a, b) =>
					a.Name > b.Name ? 1 : -1
				);
			}
			if (state.cloneOptions.Reports) {
				state.cloneOptions.Reports.sort((a, b) =>
					a.Name > b.Name ? 1 : -1
				);
			}
			if (state.cloneOptions.Grids) {
				state.cloneOptions.Grids.sort((a, b) =>
					a.Name > b.Name ? 1 : -1
				);
			}

			return JSON.parse(JSON.stringify(state.cloneOptions));
		},
		[Getters.CLIENTS]: (state) => {
			if (state.clients && state.clients.length > 0)
				return JSON.parse(
					JSON.stringify(
						state.clients.sort((a, b) => (a.Name > b.Name ? 1 : -1))
					)
				);
		},
		[Getters.PROJECTS]: (state) => {
			if (state.projects && state.projects.length > 0)
				return JSON.parse(
					JSON.stringify(
						state.projects.sort((a, b) =>
							a.Name > b.Name ? 1 : -1
						)
					)
				);
		},
	},
};
